module.exports = __webpack_public_path__ + "img/fail.a0730f33.svg";